/**********************************************************************
* fetch-weather.js - Get Weather Data from Environment Canada
* By: Tyler Heshka < tyler.h@floralacres.ca >
* 
* Version: 1.0
* Release Date: 2023-04-20
* License: Commercial. Licensed to Central Botanical Growers Ltd. o/a 
* Floral Acres Greenhouses & Garden Centre - https://floralacres.ca/
*
* This script will use asynchronus javascript to fetch Weather Data
* from Environment Canada. We use rss2json website to convert the 
* RSS data provided to to JSON data and display it on a webpage. 
*
************************************************************************/

// Environment Canada RSS feed URL for desired City
const cityUrl= 'https://weather.gc.ca/rss/city/sk-40_e.xml';
const altCityUrl = 'https://meteo.gc.ca/rss/city/sk-40_f.xml';
const apiKey = 'gmyligpoyn06cpwmdtz6meuwgfs9cpgb5yc6qbql';

// fetch data using Fetch API and rss2json
fetch('https://api.rss2json.com/v1/api.json' + '?rss_url=' + encodeURIComponent(cityUrl) + '&api_key=' + apiKey)
.then(response => response.json())
.then(data => {
    // debugging
    //console.log(data)

    // get image container
    var image = document.getElementById('weather-image');
    // "Current Conditions: Sunny, -2.0°C"
    var weather = data.items[1].title.split(',')[0].split(':')[1];
    // test for matching weather image
    switch(true) {
      case (/clear/i.test(weather)):
        // Clear Image URL
        var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/30-clear.gif?v=1683202784';
        var altText = 'Clear';
        break;
      case (/partly/i.test(weather)):
          // Cloudy Image URL
          var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/02-a-mix-of-sun-and-coud.gif?v=1684548981';
          var altText = 'Mix of Sun and Cloud';
          break;
      case (/sunny/i.test(weather)):
        // Sunny Image URL
        var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/00-sunny.gif?v=1646958523';
        var altText = 'Sunny';
        break;
      case (/cloudy/i.test(weather)):
        // Cloudy Image URL
        var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/10-cloudy.gif?v=1646958523';
        var altText = 'Cloudy';
        break;
      case (/fog/i.test(weather)):
        // Cloudy Image URL
        var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/20-fog.gif?v=1683985561';
        var altText = 'Fog';
        break;
      case (/mist/i.test(weather)):
        // Cloudy Image URL
        var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/20-fog.gif?v=1683985561';
        var altText = 'Fog';
        break;
      case (/smoke/i.test(weather)):
          // Snow Image URL
          var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/44-smoke.gif?v=1684326889';
          var altText = 'Smoke';        
          break;
      case (/snow/i.test(weather)):
        // Snow Image URL
        var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/17-snow.gif?v=1646958523';
        var altText = 'Snow';        
        break;
      case (/rain/i.test(weather)):
        // Rain Image URL 
        var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/12-rain.gif?v=1646958523';
        var altText = 'Rain'; 
        break;
      case (/thunder/i.test(weather)):
        // Rain Image URL 
        var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/09-thunder-showers.gif?v=1684930416';
        var altText = 'Thunderstorm'; 
        break;
      case (/drifting snow/i.test(weather)):
        // Drifting Snow Image URL
        var srcUrl = 'https://cdn.shopify.com/s/files/1/0421/3617/4760/files/25-drifting-snow.gif?v=1646958523';
        var altText = 'Drifting Snow';        
        break;
      default:
        // Default Image
        var srcUrl = '';
        var altText = '';
    };  
    // update image container
    image.innerHTML = '<img src="' + srcUrl + '" alt="' + altText + '" style="width: 100%" />';
      
    // get weather-title container
    var weather = document.getElementById('weather-title');
    // "Saskatoon - Weather - Environment Canada"
    weather.innerHTML = "City of " + data.feed.title.split('-')[0];
    
    // get weather-current-temp container
    var weather = document.getElementById('weather-current-temp');
    // "Current Conditions: Sunny, -2.0°C"
    weather.innerHTML = data.items[1].title.split(':')[1].split(',')[1];
  
    // get weather-current-detail container
    var weather = document.getElementById('weather-current-detail');
    // "Current Conditions: Sunny, -2.0°C"
    weather.innerHTML = data.items[1].title;

    // get weather-daytime-high continer
    var weather = document.getElementById('weather-daytime-high');
    // "Saturday: Sunny. High 15."
    weather.innerHTML = data.items[2].title.split(':')[0] + ":" + data.items[2].title.split('.')[1];

    // get weather-nighttime-low container
    var weather = document.getElementById('weather-nighttime-low');
    // "Saturday night: Clear. Low zero."
    weather.innerHTML = data.items[3].title.split(':')[0] + ":" + data.items[3].title.split('.')[1];

    // get weather-current-alerts container
    var weather = document.getElementById('weather-current-alerts');
    // "No watches or warnings in effect."
    if ( data.items[0].content == 'No watches or warnings in effect.' || data.items[0].description == 'No watches or warnings in effect.') {
      weather.innerHTML = '<span class="weather-alert-none">' + data.items[0].content + '<span>';
    } else {
      // "Persons in or near this area should be on the lookout for adverse weather conditions and take necessary safety precautions. Issued: 4:10 a.m. CST Saturday 20 May 2023"
      weather.innerHTML = '<span class="weather-alert-warning">⚠ ' + data.items[0].title.split(',')[0] + ': ' + data.items[0].content.split('.')[0] + '.<span>';
    }
    
    // get weather-observed-at container
    var weather = document.getElementById('weather-observed-at');
    // "\n<b>Observed at:</b> Saskatoon Diefenbaker Int'l Airport 6:00 AM CST Friday 28 April 2023<br><b>Condition:</b> Mostly Cloudy<br><b>Temperature:</b> 0.8\u00b0C<br><b>Pressure / Tendency:</b> 102.1 kPa falling<br><b>Visibility:</b> 24 km<br><b>Humidity:</b> 85 %<br><b>Dewpoint:</b> -1.4\u00b0C<br><b>Wind:</b> S 10 km/h<br><b>Air Quality Health Index:</b> 2<br>\n"
    weather.innerHTML = '<em>'
    + data.items[1].content.split('<br>')[0].split('<b>')[1].split(' ')[0] // Observed
    + ' ' 
    + data.items[1].content.split('<br>')[0].split('<b>')[1].split(' ')[1] // at:
    + ' '
    + data.items[1].content.split('<br>')[0].split('<b>')[1].split(' ')[6] // 6:00
    + ' '
    + data.items[1].content.split('<br>')[0].split('<b>')[1].split(' ')[7]; // AM
    + '</em>';
    
})
.catch(error => {
    // log errors
    console.error('Error:', error);
});